import styled from 'styled-components';
import StatusTag from '@/components/StatusTag';
import UserInitials from '@/trio-ui/UserInitials';

export const Tag = styled(StatusTag)`
  margin-right: 12px;
  display: flex;
`;

export const Box = styled.div`
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.07);
  background-color: ${(props) => props.theme.colors['neutral-10']};
  padding: 25px;
  margin-bottom: 16px;
  margin-left: -20px;
  margin-right: -20px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    justify-content: space-between;
    display: flex;
    align-items: stretch;
    margin: 0 -100px 16px;
    padding: 25px 105px;
  }
`;

export const Info = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const InfoResume = styled(Info)`
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 20px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin-bottom: 0;
  }
`;

export const CandidateName = styled.h3`
  color: ${(props) => props.theme.colors['neutral-100']};
  font-weight: 600;
  line-height: 18px;
  font-size: 16px;
  margin-right: 12px;
  margin-bottom: 4px;
`;

export const SimpleText = styled.p`
  color: ${(props) => props.theme.colors['neutral-100']};
  font-weight: 400;
  line-height: 21px;
  font-size: 14px;
  display: flex;
  align-items: center;

  & > svg {
    width: 15px;
    height: 15px;
    fill: ${({ theme }) => theme.colors['neutral-100']};
    margin-right: 6.5px;
  }
`;

export const SmallerText = styled(SimpleText)<{ $bold?: boolean }>`
  font-size: 12px;
  font-weight: ${({ $bold = false }) => ($bold ? 600 : 400)};
  line-height: 16.32px;
`;

export const ManagerName = styled.p`
  color: ${({ theme }) => theme.colors['primary-60']};
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
`;

export const ManagerPicture = styled(UserInitials)`
  margin-right: 8px;
  flex-shrink: 0;
`;

export const UserPicture = styled(UserInitials)`
  margin-right: 12px;
  font-size: 16px;
  flex-shrink: 0;
`;

export const ContainerSection = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  flex-direction: column;

  &:not(:first-child) {
    padding-left: 32px;
  }

  &:not(:last-child) {
    border-right: 1px solid ${({ theme }) => theme.colors['neutral-30']};
    padding-right: 32px;
  }
`;
